import React, { useEffect, useState } from 'react';
import { Avatar, Input, Spin } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment/moment.js';
import { GetTicketByIdApi, GetTicketChatApi, UpdateassingTicketApi, UpdateTicketApi } from '../../../../api/request/ib/support.js';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';
import toast from "react-hot-toast";
import { useSelector } from 'react-redux';

export default function ViewIBTicket() {

    const params = useParams();
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
    const [isLoading, setIsLoading] = useState(false);
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [ticket, setTicket] = useState(null);
    const [ticketChat, setTicketChat] = useState([]);
    const [message, setMessage] = useState('');
    const [closeTicketConfirmation, setCloseTicketConfirmation] = useState(false);
    const [assingTicketConfirmation, setAssingTicketConfirmation] = useState(false);
    const navigate = useNavigate();
    const [isCloseTicketLoading, setIsCloseTicketLoading] = useState(false);
    const { userDetails } = useSelector(state => state.user);

    const getTicket = async (isLoad = true) => {
        try {
            if (isLoad) {
                setIsLoading(true);
            }
            const { data } = await GetTicketByIdApi(params?.ticketId);
            if (data?.success) {
                setTicket(data?.data);
                setTicketChat(data?.data?.ticketCommentList);
                setIsLoading(false);
            }
            setIsLoading(false);
        } catch (error) { }
    }

    const getTicketChat = async () => {
        setIsChatLoading(true);
        try {
            let apiParams = {
                ticketId: params?.ticketId,
                userComment: null,
                adminComment: null
            }
            const { data } = await GetTicketChatApi(apiParams);
            if (data?.success) {
                setTicketChat(data?.data?.comments);
                setIsChatLoading(false);
            }
            setIsChatLoading(false);
        } catch (error) { }
    }

    useEffect(() => {
        getTicket();
        // getTicketChat();
    }, []);


    const closeTicketHandler = async () => {
        try {
            setIsCloseTicketLoading(true);
            let params = {
                ticketId: ticket?.id,
                ticketStatus: 4 // 4 -closed
            };
            const { data } = await UpdateTicketApi(params);
            if (data?.success) {
                setIsCloseTicketLoading(false);
                toast.success(data?.message);
                setCloseTicketConfirmation(false);
                getTicket();
            }
        } catch (error) {
            setIsCloseTicketLoading(false);
        }
    }

    const assingTicketHandler = async () => {
        try {
            setIsCloseTicketLoading(true);
            let params = {
                TicketId: ticket?.ticketId,
            };
            const { data } = await UpdateassingTicketApi(params);
            if (data?.success) {
                setIsCloseTicketLoading(false);
                toast.success(data?.message);
                setAssingTicketConfirmation(false);
                getTicket();
                navigate('/ib/support');
            }
        } catch (error) {
            setIsCloseTicketLoading(false);
        }
    }

    const sendMessage = async () => {
        if (!message) {
            return;
        }
        try {
            let formData = new FormData();
            formData.append("TicketId", params?.ticketId);
            formData.append("Comments", message);
            let apiHeader = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };
            const { data } = await GetTicketChatApi(formData, apiHeader);
            if (data?.success) {
                getTicket(false);
                setMessage('');
            }
        } catch (error) { }
    }

    const getInitials = (name) => {
        const nameParts = name.trim().split(' ');
        const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
        return initials.toUpperCase();
    };


    return (
        <>
            {(isLoading) ? (
                <div className="flex justify-center flex-col mt-[20%]">
                    <Spin size="large" />
                    <p className="primary text-center mt-2">Loading...</p>
                </div>
            ) : (
                <div>
                    <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                        <div className='px-4 lg:px-6 pb-4 border-b border-light flex flex-wrap justify-between items-center'>
                            <p className='text-[#2F2B3D] text-xl font-semibold'>Ticket - #{ticket?.ticketNo}</p>
                            {
                                ticket?.status === 'Open' &&
                                <div>
                                    <button className="bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500 mr-4 " onClick={() => setAssingTicketConfirmation(true)}>Pass to Admin</button>
                                    <button className="bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500" onClick={() => setCloseTicketConfirmation(true)}>Close Ticket</button>
                                </div>

                            }
                        </div>
                        <div className="lg:p-6 p-4">
                            <p className="primary text-xl font-semibold">{ticket?.title}</p>
                            <p className="primary text-base mt-2">{ticket?.description}</p>
                        </div>
                    </div>

                    <div className='border-[2px] border-light rounded-xl pt-4 w-full mt-5'>
                        <div className='flex items-center px-4 lg:px-6 pb-4 border-b border-light'>
                            <Avatar size={40} className='bg-primary uppercase'>{getInitials(`${ticket?.firstName} ${ticket?.lastName}`)}</Avatar>
                            <p className='font-semibold text-base ml-2 text-[#2F2B3D]'>{`${ticket?.firstName} ${ticket?.lastName}`}</p>
                        </div>
                        <div className='max-h-[500px] min-h-[200px] overflow-y-auto'>
                            {
                                ticketChat?.length > 0 ? (
                                    <div className='px-4 lg:px-6'>
                                        {
                                            ticketChat?.map((message, index) => (
                                                <>
                                                    {/* Sent message */}
                                                    {userDetails?.id === message?.createdBy ? (
                                                        <div className='flex justify-end w-full my-6'>
                                                            <div className='w-[70%] md:w-[50%] lg:w-[40%] ml-3'>
                                                                <div className='flex justify-between mb-1'>
                                                                    <p className='text-sm text-[#2F2B3D] font-medium'>{`${userDetails?.firstName} ${userDetails?.lastName}`}</p>
                                                                    <p className='text-sm text-[#2F2B3D] opacity-70 font-medium'>{moment(message?.createdDate).format('DD-MM-YYYY LT')}</p>
                                                                </div>
                                                                <p className='bg-primary-light text-[#2F2B3D] rounded-b-md rounded-tl-md font-medium py-2 px-4'>{message?.comments}</p>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                    {/* Received message */}
                                                    {userDetails?.id !== message?.createdBy ? (
                                                        <div key={index} className='flex w-full my-6'>
                                                            <Avatar size={40} className='bg-primary uppercase' src={message?.profileImage}>
                                                                {getInitials(`${ticket?.firstName} ${ticket?.lastName}`)}
                                                            </Avatar>
                                                            <div className='w-[70%] md:w-[50%] lg:w-[40%] ml-3'>
                                                                <div className='flex justify-between mb-1'>
                                                                    <p className='text-sm text-[#2F2B3D] font-medium'>{`${ticket?.firstName} ${ticket?.lastName}`}</p>
                                                                    <p className='text-sm text-[#2F2B3D] opacity-70 font-medium'>{moment(message?.createdDate).format('DD-MM-YYYY LT')}</p>
                                                                </div>
                                                                <p className='bg-primary-light text-[#2F2B3D] rounded-b-md rounded-tr-md py-2 px-4 font-medium'>{message?.comments}</p>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </>
                                            ))
                                        }
                                    </div>
                                ) : (
                                    <div className='p-4 lg:p-6'>
                                        <p className='opacity-50 primary text-lg font-semibold'>Have any query?</p>
                                        <p className='opacity-50 primary'>Ask to our team...</p>
                                    </div>
                                )
                            }
                        </div>
                        <ConfirmationModal
                            isOpen={closeTicketConfirmation}
                            setIsOpen={setCloseTicketConfirmation}
                            message='Are you sure you want to close this ticket?'
                            onConfirm={closeTicketHandler}
                            isLoading={isCloseTicketLoading}
                            loadingLabel='Closing ticket...'
                        />

                        <ConfirmationModal
                            isOpen={assingTicketConfirmation}
                            setIsOpen={setAssingTicketConfirmation}
                            message='Are you sure you want to assing this ticket?'
                            onConfirm={assingTicketHandler}
                            isLoading={isCloseTicketLoading}
                            loadingLabel='Assing ticket...'
                        />
                        {
                            ticket?.status === 'Open' &&
                            <div className='p-4 lg:p-6'>
                                <Input
                                    className='transperant-input py-2 rounded-lg search-bar text-base w-full'
                                    placeholder="Type a message..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onPressEnter={sendMessage}
                                    suffix={
                                        <svg onClick={sendMessage} xmlns="http://www.w3.org/2000/svg" fill="#e5e5e5" viewBox="0 0 24 24" stroke-width="1.5" stroke={primaryColor} className="w-6 h-6 cursor-pointer duration-300">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                        </svg>
                                    }
                                />
                            </div>
                        }
                    </div>
                </div>
            )}
        </>
    )
}